// Client side of the hosting callables in functions/hosting.js.
import { getFunctions, httpsCallable } from "firebase/functions";
import app from "../firebase";

let functions;

function callable(name) {
  return async (data = {}) => {
    functions = functions || getFunctions(app);
    const { data: result } = await httpsCallable(functions, name)(data);
    return result;
  };
}

const authorize = callable("authorizeHostedStart");
const release = callable("releaseHostedStart");
const replay = callable("createReplay");
const welcome = callable("claimWelcomeBonus");

// Functions deployed after the app would otherwise block every start.
export const isNotDeployed = (err) => err?.code === "functions/not-found";

const hostingService = {
  authorizeStart: (roomDocId, { payWithCoins = false } = {}) => authorize({ roomDocId, payWithCoins }),
  releaseStart: (roomDocId) => release({ roomDocId }),
  createReplay: (roomDocId) => replay({ roomDocId }),
  claimWelcomeBonus: (source) => welcome({ source }),
};

export default hostingService;
